import React from "react";
import { Button as ButtonB, Glyphicon } from "react-bootstrap";
import tooltip from "../../../MapStore2/web/client/components/misc/enhancers/tooltip";

const MapStoreButton = tooltip(ButtonB);

interface ButtonProps {
    onClick?: Function;
    tooltip: string;
    glyph: string;
    id: string;
    disabled: boolean;
    className: string;
}

export const Button = (props: ButtonProps) => {
    if (props.onClick) {
        return (
            <MapStoreButton
                id={props.id}
                key={props.id}
                className={`square-button ms-close btn btn-primary ${props.className}`}
                onClick={props.onClick}
                disabled={props.disabled}
                tooltip={props.tooltip}
                tooltipPosition={"bottom"}
            >
                <Glyphicon glyph={props.glyph} />
            </MapStoreButton>
        );
    } else {
        return null;
    }
};
